import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";
import Images from "@/assets/images";
import { Image } from "expo-image";

const OnboardSlide15 = () => {
  return (
    <View style={styles.container}>
      <Image
        source={Images.brands}
        style={styles.brands}
        contentFit="contain"
      />
      <Text style={styles.title}>You get 2 free claims{"\n"}every month</Text>
      <Text style={styles.subtitle}>
        Use them anytime. {"\n"}Invite friends to earn extra.
      </Text>
    </View>
  );
};

export default OnboardSlide15;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    gap: 16,
  },
  brands: {
    width: 356,
    height: 180,
  },
  title: {
    fontFamily: FontFamilies.InterTight.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#EBFFEE",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    opacity: 0.7,
    color: "#EBFFEE",
    textAlign: "center",
  },
});
